import useExplorerData from './useExplorerData';

interface IFetchExplorerData {
  globalCoverage: number;
  totalUniqueKm: number;
  totalKmMapped: number;
}

export default function useCoverageStats() {
  const { data, isError, isLoading } = useExplorerData();

  const mostRecentDay = data?.stats?.mostRecentDay || '';
  const stats = data?.stats;
  const totalUniqueKm = stats?.byDay?.[mostRecentDay]?.totalUniqueKm || 0;
  const totalKmMapped = stats?.byDay?.[mostRecentDay]?.totalKm || 0;
  const globalCoverage = Math.round((totalUniqueKm / 60000000) * 100);

  return {
    data: {
      totalKmMapped,
      globalCoverage,
      totalUniqueKm,
    } as IFetchExplorerData,
    isLoading,
    isError,
  };
}
